import { WeblinkFault } from '../weblink-fault/weblink-fault';
import { Company } from '../../../core/company/company';
import { Project } from '../../../core/project/project';
import { Status } from '../../../core/status/status';
import { FaultFieldMapping  } from '../fault-field-mapping/fault-field-mapping';

export class WeblinkData {
  Company: Company;
  Project: Project;
  Faults: WeblinkFault[];
  Fields: FaultFieldMapping[];
  Status: Status[];
  Settings: WeblinkSettings;
}

export class WeblinkSettings {
  IsDescriptionRequired: boolean;
  IsAttachmentRequired: boolean;
}
